import { API } from '@/shared/api/modules';
import type { GetAverageNumberOfResidentsRequestDto } from '@/shared/api/modules/facilities';
import { keepPreviousData, queryOptions } from '@tanstack/react-query';

export const getAverageNumberOfResidentsQueryOptions = (
  params: GetAverageNumberOfResidentsRequestDto
) =>
  queryOptions({
    queryKey: ['average-number-of-residents', params],
    queryFn: async ({ signal }) =>
      await API.facilities.getAverageNumberOfResidents(params, { signal }),
    placeholderData: keepPreviousData,
    enabled: !!params.from && !!params.to,
  });
